import { useLocation } from 'react-router-dom';
import { environment } from 'src/config/environment';
import { verificationIdParam } from 'src/routes';

export const useVerificationId = () => {
  const search = new URLSearchParams(useLocation().search);

  if (environment.isWebSdk) {
    return localStorage.getItem(verificationIdParam) || undefined;
  }

  return (
    search.get(verificationIdParam) ||
    localStorage.getItem(verificationIdParam) ||
    undefined
  );
};
